/**
 * Reads the app base href from the document `<base>` tag.
 * Avoids APP_BASE_HREF injection, which is not provided in this app bootstrap.
 */
export function getAppBaseHref(): string {
  if (typeof document === "undefined") {
    return "/";
  }

  const baseElement = document.querySelector("base");
  if (!baseElement?.href) {
    return "/";
  }

  try {
    const pathname = new URL(baseElement.href).pathname;
    return pathname.endsWith("/") ? pathname : `${pathname}/`;
  } catch {
    return "/";
  }
}

/**
 * Resolves a path under `assets/` using the document base href.
 */
export function toAssetUrl(assetPath: string): string {
  if (/^(https?:|data:|\/\/)/.test(assetPath)) {
    return assetPath;
  }

  if (assetPath.startsWith("/")) {
    return assetPath;
  }

  const baseHref = getAppBaseHref();
  const base = baseHref.endsWith("/") ? baseHref : `${baseHref}/`;
  return `${base}${assetPath.replace(/^\//, "")}`;
}
